import { useState } from "react";
import { Car, FileSpreadsheet, Upload } from "lucide-react";
import { Zeiterfassung } from "@/components/crm/lohn/Zeiterfassung";
import { Fahrt } from "@/components/crm/controlling/Fahrt";

export function ZeiterfassungFahrtenbuch({ monat, onChanged }) {
  const [fahrtKey, setFahrtKey] = useState(0);
  const importiert = () => { setFahrtKey((k) => k + 1); onChanged?.(); };
  return (
    <div className="space-y-5 min-w-0" data-testid="zeiterfassung-fahrtenbuch">
      <div className="rounded-2xl bg-slate-900 text-white p-4">
        <h3 className="font-['Manrope'] font-bold text-lg">Zeiterfassung & Fahrtenbuch</h3>
        <p className="text-sm text-slate-300 mt-1 max-w-3xl">Mitarbeiterdateien (Excel-Fahrtenbuch, Kilanka-Export als CSV/PDF) hochladen, auslesen, prüfen und nach Bestätigung in die Monatsdaten übernehmen. Darunter die Monatssummen „Fahrtzeit & Kilometer“ je Mitarbeiter. Fahrzeit zählt zur Arbeitszeit, wird aber nur einmal berücksichtigt; Kilometer laufen getrennt über die hinterlegten Erstattungsregeln (Heimweg-Regel bleibt).</p>
        <div className="flex flex-wrap gap-2 mt-3 text-xs">{[[FileSpreadsheet, "1 · Excel-Import mit Vorschau"], [Upload, "2 · Uploads je Mitarbeiter prüfen & bestätigen"], [Car, "3 · Monatssummen Fahrtzeit & Kilometer"]].map(([I, t]) => <span key={t} className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1"><I className="h-3.5 w-3.5" />{t}</span>)}</div>
      </div>
      <Zeiterfassung monat={monat} onImported={importiert} />
      <section className="space-y-2" data-testid="fahrt-monatssummen">
        <h4 className="font-['Manrope'] font-bold text-slate-900 inline-flex items-center gap-2"><Car className="h-4 w-4 text-slate-500" />Monatssummen Fahrtzeit & Kilometer</h4>
        <Fahrt key={fahrtKey} monat={monat} onChanged={onChanged} />
      </section>
    </div>
  );
}
